import {showSuccess, showError} from 'perform-base/js/flashes';

export default function () {
  $('#addExpenseForm').submit(function() {
    var form = $(this);
    $.ajax({
      url: form.attr('action'),
      type: 'POST',
      data: form.serialize(),
      success: function (data) {
        form.find('#amount').val('');
        form.find('#amount').focus();
        form.find('#description').val('');
        form.find('#note').val('');
        showSuccess(data.message);
        loadRecent();
      },
      error: function (data) {
        showError(data.responseJSON.message);
      }
    });

    return false;
  });

  var template = _.template($('#template-expense').html());
  var recentUrl = $('.recent-table').data('url');

  var loadRecent = function() {
    $.ajax({
      url: recentUrl,
      type: 'get',
      success: function (data) {
        $('.recent-table').html('');
        for (var i=0; i < data.length; i++) {
          $('.recent-table').append(template(data[i]));
        }
      }
    });
  };

  loadRecent();
};



// WEBPACK FOOTER //
// ./assets/js/add-expense.js